<script lang="ts">
  /* /pub/:slug/where-to-buy used to be a page of its own. The store finder is
     a band of the company page now (see WhereToBuySection), so links and
     bookmarks that still point here land on it. */
  import { onMount } from "svelte";
  import { replace } from "svelte-spa-router";

  let { params }: { params: { slug: string } } = $props();

  onMount(() => {
    const slug = params?.slug ?? "";
    replace(slug ? `/pub/${slug}?s=where-to-buy` : "/");
  });
</script>
